import { LitElement, TemplateResult, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import type { ImageRatio } from '../../utilities/image-ratio';
import { SlotControllerLegacy } from '../../controllers/slot-controller-legacy';
import innerCSS from './se-image-cta.inner.pcss?inline';
import '../se-container/se-container';

/**
 * The SeImageCta component
 * @element se-image-cta
 * @slot image - image
 * @slot heading - title/se-heading
 * @slot description - paragraph text
 * @slot cta - se-link
 */
@customElement('se-image-cta')
export class SeImageCta extends LitElement {
  private stylesheetController = new AdoptedStyleSheets(this, {
    encapsulatedCSS: innerCSS,
  });

  /**
   * Crop shape for the image. Absent keeps the design's square;
   * 'original' keeps each image's own proportions. Applied by
   * styles/image-ratio.base.pcss via --se-image-ratio.
   */
  @property({ type: String, attribute: 'image-ratio', reflect: true })
  imageRatio?: ImageRatio;

  slots = new SlotControllerLegacy(this, true);

  render(): TemplateResult {
    return html`<section class="se-image-cta">
      <se-container>
        <div class="se-image-cta--wrapper">
          <div class="se-image-cta--image">
            <slot name="image"></slot>
          </div>
          <div class="se-image-cta--content">
            <slot name="heading"></slot>
            <slot name="description"></slot>
            <slot name="cta"></slot>
          </div>
        </div>
      </se-container>
    </section> `;
  }
}
